export default __webpack_public_path__ + "media/zurb/img/playground/ux-card-etymology-d5bfa5d5f93da44ea0025268cb55ab98.png";